import { Component, Emit, Prop, Vue,Watch } from 'vue-property-decorator';
import moment from 'moment';
import { toCamel } from 'snake-camel';
import store from '@/assets/common/store/store';
import { cropList } from "@/types/Component";
import EmptyGraphMessage from '@/assets/common/AggregationFunction/EmptyGraphMessage/EmptyGraphMessage.vue';

@Component({
    components: {
        EmptyGraphMessage
    }
})
export default class ReferencePlantingList extends Vue {
    @Prop({ default: false })
    private readonly isShow!: boolean;
    
    @Prop()
    private modeType?: string
    @Prop()
    private isWorkRecordPopup?: string

    @Prop()
    private selectedGoalId?: string

    screen = 'REFERENCEPLANTINGLIST'; 
    private list: any | null = null
    baseUrl = '/admin/reference_planting_list';
    selectScreenManagement = '/graphScreenManagement';
    cropDetails = [] as cropList;
    selectedStartDate: string | Date = new Date();
    selectedEndDate: string | Date = new Date();
    startDate: string | Date = new Date();
    endDate: string | Date = new Date();
    private referencePlantingList =  [] as any[];
    private selectedAgriFieldId : string | null = null;
    private selectedPlantingId : string | null = null;
    private selectedWorkItemId : string | null = null;
    private selectedCropId : string | null = null;
    private selectedTitleId : string | null = null;
    private isButtonDisabled = false;
    private agriFields = [] as any[];
    private plantings = [] as any[];
    private goalTitles = [] as any[];
    private workItems = [] as any[];
    private selectedPlantingName = '';
    private selectedAgriFieldName = '';
    private selectedWorkItemName = '';
    private selectedWorkerName = '';
    private includeHiddenFlag = false;
    private isSpinnerLoading = false;
    private sortOrder = true;
    
    
    private init() {
        const currentDate = new Date();
        this.selectedStartDate = moment(currentDate).startOf('month').format('YYYY-MM-DD');
        this.selectedEndDate = moment(currentDate).endOf('month').format('YYYY-MM-DD');
        this.startDate = this.selectedStartDate;
        this.endDate = this.selectedEndDate;
        this.getReferencePlantingList();
        this.getAgriFields();
        this.getPlantings();
        this.getWorkItems();
        this.getCrops();
    }
    
    closeModal() {
        this.$emit('update:isShow', false);
    }

    @Watch("isShow")
    handlePlantingListModal() {
        if(this.isShow){
            this.init();
        }
    }
            

    @Emit('inputChanged')
    private inputChanged(){
        if(store.getters.isInputChanged==false){
         this.$store.dispatch('doUpdateIsInputChanged', true);
        }
    }

    getReferencePlantingList() {
        this.$apiClient.doRequest('get', `${this.baseUrl}`).then(res => {
        setTimeout(() => {
            this.isSpinnerLoading = false;
            }, 500);
          this.referencePlantingList = res.referencePlantingList
          if(res.selectedItems!=null){
            this.selectedCropId = res.selectedItems.cropId
            this.selectedAgriFieldId = res.selectedItems.agriFieldId
            this.selectedPlantingId = res.selectedItems.plantingId
            this.selectedWorkItemId = res.selectedItems.workItemId
            this.selectedStartDate = res.selectedItems.displayFromDate ? res.selectedItems.displayFromDate : ""
            this.selectedEndDate = res.selectedItems.displayToDate ? res.selectedItems.displayToDate : ""
            this.startDate = res.selectedItems.displayFromDate ? res.selectedItems.displayFromDate : ""
            this.endDate = res.selectedItems.displayToDate ? res.selectedItems.displayToDate : ""
            this.includeHiddenFlag = res.selectedItems.includeHiddenFlag
            if ((this.selectedStartDate > this.selectedEndDate) || (this.selectedStartDate === '' && this.selectedEndDate === '') || (this.selectedStartDate === '' && this.selectedEndDate !== '') 
                || (this.selectedStartDate !== '' && this.selectedEndDate === '')) {
                this.isButtonDisabled = true;
                this.referencePlantingList =[];
              }else{
                this.isButtonDisabled = false;
            }
          }
        })
    }

    getAgriFields() {
        this.$apiClient.doRequest('get','/agri_fields?with_hidden=true').then((res) => {
        this.agriFields = res.agri_fields
        this.selectedAgriFieldName = this.agriFields.find(item=>item.id==this.selectedAgriFieldId)?.name
        })
    }

    getPlantings() {
        this.$apiClient.doRequest('get','/plantings?with_hidden=true').then((res) => {
        this.plantings = res.plantings.sort((a:any,b:any) => a.name.localeCompare(b.name))
        this.selectedPlantingName = this.plantings.find(item=>item.id==this.selectedPlantingId)?.name
       })
    }

    getCrops() {
        this.$apiClient.doRequest("get", `/crops/cropBytenentId`).then(res => {
            this.cropDetails = res.crops;
            this.cropDetails.sort((a:any, b:any) => a.name.localeCompare(b.name));
        });
    }

    getWorkItems() {
        this.$apiClient.doRequest('get','/work_items?with_hidden=true').then((res) => {
        this.workItems = res.work_items
        this.selectedWorkItemName = this.workItems.find(item=>item.id==this.selectedWorkItemId)?.name
        })
    }

    dateNavigation(action: string) {
        if (!this.selectedStartDate || !this.selectedEndDate) return;
        this.validateDates()
        if(this.isButtonDisabled == false){
        const updateDate = (date: moment.MomentInput, offset: moment.DurationInputArg1, unit: moment.unitOfTime.Base) => moment(date).add(offset, unit).format('YYYY-MM-DD');
        const daysDifference = moment(this.selectedEndDate).diff(this.selectedStartDate, 'days')+1;
        const offset = (action === 'previous') ? -daysDifference : daysDifference;
        this.selectedStartDate = updateDate(this.selectedStartDate, offset, 'days');
        this.selectedEndDate = updateDate(this.selectedEndDate, offset, 'days');
        this.startDate = this.selectedStartDate;
        this.endDate = this.selectedEndDate;
        } else {
            this.isButtonDisabled = false
        }
    }

    validateDates() {
        if (!this.selectedStartDate || !this.selectedEndDate) return;
        if (this.selectedStartDate > this.selectedEndDate) {
          this.selectedStartDate = this.startDate;
          this.selectedEndDate = this.endDate;
          this.isButtonDisabled = true;
        } else {
          this.isButtonDisabled = false;
          this.startDate = this.selectedStartDate;
          this.endDate = this.selectedEndDate;
        }
    }

    handleSelectChange(flag = true) {
        this.selectedPlantingName = this.plantings.find(item=>item.id==this.selectedPlantingId)?.name
        this.selectedAgriFieldName = this.agriFields.find(item=>item.id==this.selectedAgriFieldId)?.name
        this.selectedWorkItemName = this.workItems.find(item=>item.id==this.selectedWorkItemId)?.name
        const params = {
          cropId: this.selectedCropId,
          plantingId: this.selectedPlantingId,
          agriFieldId: this.selectedAgriFieldId,
          selectedWorkId: this.selectedWorkItemId,
          startDate: this.selectedStartDate,
          endDate: this.selectedEndDate,
          screenName: this.screen,
          includeHiddenFlag: this.includeHiddenFlag
        }
        this.$apiClient.doRequest('post', `${this.selectScreenManagement}`,params).then(res => {
            if (flag) {
                this.refreshTable();
            }
        }).catch(error=>{
            this.$toasted.error('データの取得に失敗しました。')
        })
    } 

    refreshTable () {
        this.referencePlantingList = []
        this.isSpinnerLoading = true
        this.getReferencePlantingList();
    }

    selectPlanting(id = ''){
        this.$emit('update:isShow', id);
    }

    private convertDate(date: Date): string {
        if (date) {
            const d = new Date(date);
            return `${d.getFullYear()}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getDate().toString().padStart(2, '0')}`;
        }
        return "-";
    }

    get filterAgriFields() {
        return this.includeHiddenFlag ? this.agriFields : this.agriFields.filter(a => this.selectedAgriFieldId == a.id || !a.is_hidden);
    }  
    
    get filterWorkItems() {
        return this.includeHiddenFlag ? this.workItems : this.workItems.filter(wi => this.selectedWorkItemId == wi.id || !wi.is_hidden);
    } 

    get filterPlantings() {
        return this.includeHiddenFlag ? this.plantings : this.plantings.filter(p => this.selectedPlantingId == p.id || !p.is_hidden);
    }

    get filteredPlantings() {
        if (this.selectedCropId === null) {
            return this.includeHiddenFlag ? this.plantings : this.plantings.filter(p => this.selectedPlantingId == p.id || !p.is_hidden);
        } else {
            return this.includeHiddenFlag ? this.plantings.filter(p => p.crop.id === this.selectedCropId) : this.plantings.filter(p => this.selectedPlantingId == p.id || (!p.is_hidden && p.crop.id === this.selectedCropId));
        }
    }
    handleCropSelect() {
        this.selectedPlantingId = null
    }

    handlePlantingSelect() {
        if (this.selectedPlantingId != null) {
            const selectedPlanting = this.plantings.find(p => p.id === this.selectedPlantingId);
            if (selectedPlanting) {
                this.selectedCropId = selectedPlanting.crop.id;
            }
        }
    }

    private sort(fieldName: string): void {
        this.sortOrder = !this.sortOrder;
        this.referencePlantingList.sort((a, b) => {
            const aValue = a[fieldName];
            const bValue = b[fieldName];
            if (aValue === null && bValue === null) return 0;
            if (aValue === null) return 1;
            if (bValue === null) return -1;
            if (typeof aValue === 'string' && typeof bValue === 'string') 
                return this.sortOrder ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
            if (typeof aValue === 'number' && typeof bValue === 'number') 
                return this.sortOrder ? aValue - bValue : bValue - aValue;
            return this.sortOrder ? String(aValue).localeCompare(String(bValue)) : String(bValue).localeCompare(String(aValue));
        });
     }

     buttonValidation(){
        if((this.selectedStartDate > this.selectedEndDate) || (this.selectedStartDate === '' && this.selectedEndDate === '') || (this.selectedStartDate === '' && this.selectedEndDate !== '') 
            || (this.selectedStartDate !== '' && this.selectedEndDate === '')){
            this.isButtonDisabled = true;
        } else {
            this.isButtonDisabled = false;
        }
      }
}
